import axios from '../utils/request'

const login = {
    // 获取用户信息
    getUserInfo() {
        return axios.get('/user/user_info')
    },
    // 团队申请
    teamApply(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/team-application',
            data
        })
    },
    // 同意/主动申请团队
    joinApply(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/inviteAndApply',
            data: data
        })
    },
    // 修改用户状态
    editUserStatus(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/modify_enterprise_user_status',
            data
        })
    },
    // 获取企业邀请列表
    getTeamInviteInfo() {
        return axios({
            method: 'get',
            url: '/enterprise/user/v1/get_enterprise_invitation'
        })
    },
    // 获取用户的企业信息
    getUserEnterpriseInfo(data) {
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_user_info',
            params: data
        })
    },
    // 获取团队成员列表
    getTeamList(data) {
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_enterprise_members',
            params: data
        })
    },
    // 移除成员
    removeUser(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/remove_enterprise_user',
            data
        })
    },
    // 邀请用户/申请加入团队
    inviteUser(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/invite_or_apply',
            data
        })
    },
    // 修改成员权限
    editUserAuthInfo(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/modify_user_auth',
            data
        })
    },
    // 获取用户权限信息
    getUserAuthInfo(data) {
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_user_auth',
            params: data
        })
    },
    getTeamInfo() {
        return axios({
            method: 'get',
            // url: 'enterprise/v1/get_enterprise_info',
            url: 'enterprise/v2/get_enterprise_info',
        })
    },
    getPublicDicList(data) {
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_share_dictionary_list',
            params: data
        })
    },
    // 添加企业词库
    addPublicDic(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/add_share_dic_info',
            data
        })
    },
    deleteDic(data) {
        return axios({
            method: 'post',
            url: 'enterprise/v1/delete_share_dic',
            data
        })
    },
    // 共享词典设置
    publicDicSetting(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/modify_enterprise_dict',
            data
        })
    },
    // 团队共享词典信息
    getDicInfo() {
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_dict_options',
        })
    },
    // 获取词表
    getTeamWordList(data) {
        return axios({
            method: 'post',
            url: '/enterprise-dic/get_list',
            data
        })
    },
    // 添加一个词
    addTeamWord(data) {
        return axios({
            method: 'post',
            url: '/enterprise-dic/add_one',
            data
        })
    },
    deleteTeamWord(data) {
        return axios({
            method: 'post',
            url: '/enterprise-dic/delete_one',
            data
        })
    },
    updateTeamWord(data) {
        return axios({
            method: 'post',
            url: '/enterprise-dic/update_one',
            data
        })
    },
    // 用户同意企业邀请  企业同意用户申请
    agreeTeamApply(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/pass_apply_or_invite',
            data
        })
    },
    // 查询当前企业词典
    getEnterpriseDic() {
        return axios({
            method: 'get',
            url: '/enterprise/v1/share_dic_in_use'
        })
    },
    getEnterpriseDicInfo() {
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_enterprise_dict_in_use'
        })
    },
    // 修改姓名
    editUserName(data) {
        return axios({
            method: 'post',
            url: '/enterprise/user/v1/update_enterprise_username',
            data
        })
    },
    // 获取企业自建词典
    getEnterpriseSelfDic() {
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_enterprise_dic',
        })
    },
    // 权限设置
    editUserRole(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/updateAuth',
            data
        })
    },
    // 启用/停用词典
    edutDicStatus(data) {
        return axios({
            method: 'post',
            url: '/enterprise/v1/modify_share_dic_status',
            data
        })
    },
    // 退出团队
    exitTeam() {
        return axios({
            method: 'post',
            url: '/enterprise/v1/quit_enterprise',
        })
    },
    deleteManyWords(data) {
        return axios({
            method: 'post',
            url: '/enterprise-dic/delete_many',
            data
        })
    },
    applyJoinTeam(data) {
        return axios({
            method: 'post',
            url:'/enterprise/user/v1/apply_join_enterprise',
            data
        })
    },
    getEnterpriseApplyInfo(){
        return axios({
            method: 'get',
            url: '/enterprise/v1/get_user_apply'
        })
    },
    getApplyInfo(){
        return axios({
            method: 'get',
            url: '/enterprise/user/v1/get_apply_enterprise_info'
        })
    },
    exportTeamDicOfMyDic(data) {
        return axios({
            method: 'post',
            url: '/enterprise-dic/person_to_enterprise_dic',
            data
        })
    },
    // 清空团队词汇
    deleteAllWords(data) {
        return axios({
            url: '/enterprise-dic/delete_all_word',
            method: 'post',
            data
        })
    },
    // 获取行业次词库
    getIndustryDic() {
        return axios({
            url: '/user/get_word_library',
            method: 'get',
        })
    },
    // 选择行业词库
    selectIndustryDic(data) {
        return axios({
            url: '/user/select_word_library',
            method: 'post',
            data
        })
    },
    // 基于用户端（网页端）的网站巡检接口
    // 添加一条信息
    websiteAddOne(data) {
        return axios({
            url: '/misscut/website/add_one',
            method: 'post',
            data
        })
    },
    // 删除一条信息
    websiteDeleteOne(data) {
        return axios({
            url: '/misscut/website/delete_one',
            method: 'post',
            data
        })
    },
    // 获取列表信息
    websiteList(data) {
        return axios({
            url: `/misscut/website/get_list?size=${data.size}&num=${data.num}`,
            method: 'get',
            data
        })
    },
    // 校对结果下载
    websiteDownload(data) {
        return axios({
            url: `/misscut/website/download`,
            method: 'post',
            data,
            responseType: "arraybuffer"
        })
    },
    // 巡检校对
    websiteCheck(data) {
        return axios({
            url: `/misscut/website/check`,
            method: 'post',
            data
        })
    },
    // 更新巡检信息
    websiteUpdateOne(data) {
        return axios({
            url: `/misscut/website/update_one`,
            method: 'post',
            data
        })
    },
    editPassword(data) {
        return axios.put('/user/pwd',data)
    },
}

export default login